<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-02-23 11:05:55
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2026-08-27 14:23:30
 * @FilePath: \qctsw-vue\packages\app\src\pages\complaint\components\ComplaintColumnAll.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { APP_ROUTER, cityName } from '@qctsw/common'
import { timeFormat } from '@qctsw/utils'
import { getComplainTypeCode } from '../hooks/list'
import { logicComplaintColumnAll } from '~/logic/complaint/column'
import { getIssueText, isOnlyRouteQueryKeyChange, useGetRouteQuery } from '~/shared/function'

const router = useRouter()

const page = useGetRouteQuery('page', '1')
const type = useGetRouteQuery('type', '0')
const sub = useGetRouteQuery('sub', '0')

const {
  state,
  list,
  pagination,
  getPage,
} = logicComplaintColumnAll()

useActivatedWatch(() => [

  router?.afterEach((to, from) => {
    if (to.path !== from.path)
      return
    const isOnlyPageQueryChange = isOnlyRouteQueryKeyChange('page', to.query, from.query)

    if (!isOnlyPageQueryChange)
      pagination.initPagination()

    nextTick(() => {
      // console.log(type.value, sub.value)

      getPage(page.value, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })
    })
  }),
])

await getPage(page.value, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })

function getMore() {
  const pageNum = pagination.pagination.page + 1
  getPage(pageNum, { complainTypeCode: getComplainTypeCode(type.value, sub.value) })
}
</script>

<template>
  <div>
    <UtilLoadState :state="state" :length="list.length" type="up" :reload-handler="() => getPage(page, { complainTypeCode: getComplainTypeCode(type, sub) })">
      <baseList :state="state" @load="getMore">
        <template v-if="list.length">
          <div v-for="item, index in list" :key="index" class="border-b-1 border-slate-2 py-sm block">
            <NuxtLink :to="APP_ROUTER.complaintDetail(item.id)" class="hover:text-orange-6 flex">
              <UtilComplaintStatus v-if="!isNaN(Number(item.complainStatusCode)) && !item.complainScoreCode" :code="Number(item.complainStatusCode)" />
              <UtilComplaintScore v-if="!isNaN(Number(item.complainScoreCode))" :code="item.complainScoreCode" />
              <span class="text-blue-5 mr-0.5">
                <UtilQrcode :to="APP_ROUTER.complaintDetail(item.id)" />
              </span>
              <span class="font-bold line-clamp-1">{{ item.title }}</span>
            </NuxtLink>
            <span class="flex items-center text-3.5 my-sm">
              <span class="mr-6">
                品牌：{{ item.vendorName + item.seriesName }}
              </span>
              <span class="mr-6">
                问题：{{ getIssueText(item.issueTypeCodes) }}
              </span>
              <span v-if="item.dealerCityId" class="mr-6">
                地区：{{ cityName(item.dealerCityId) }}
              </span>
            </span>
            <UtilContentTips
              :tips-data="{
                date: (item.resultCreateTime || item.scoreTime || item.createTime),
                favorCount: item.goodCount || 0,
                lookCount: item.lookCount ?? 0 }"
            />
          </div>
        </template>
      </baseList>
    </UtilLoadState>
    <!-- <BasicPagination
      v-if="pagination.pagination.pageCount > 1"
      class="mb-xl mt-xl max-w-100 mx-auto"
      :page="pagination.pagination.page"
      :total="pagination.pagination.pageCount"
      :to="(page) => APP_ROUTER.complaintList({ page, type, sub })"
    /> -->
  </div>
</template>

<style lang='scss' scoped>

</style>
